import css from 'styled-jsx/css';

import { colors } from 'components/styles/variables';

const buttonCSS = css`
  .button {
    user-select: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    background-color: ${colors.ALR1};
    color: white;
    font-weight: 1.5em;
    cursor: pointer;
    border: 0;
    display: flex;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    font-family: inherit;
  }

  .button:active,
  .button:hover,
  .button:focus {
    color: white;
    background-color: ${colors.ALR2};
  }
`;

export default buttonCSS;
